(() => {
  'use strict';
  const KEY = 'avontic-business-quote-draft-v2';
  const PREVIOUS = 'avontic-business-quote-previous-v3';
  const read = key => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const save = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } };
  const apply = async () => {
    const root = document.querySelector('[data-avb]');
    const form = root?.querySelector('form[data-avb-form], form.avb-quote');
    if (!form || root.querySelector('[data-avb-success-scope]') || root.dataset.avtQuoteReady) return;
    root.dataset.avtQuoteReady = 'true';
    const panels = [...root.querySelectorAll('[data-avt-quote-context]')];
    const text = { ...JSON.parse(panels[0]?.querySelector('[data-avt-quote-text]')?.textContent || '{}'), ...JSON.parse(panels[0]?.querySelector('[data-avt-quote-state-text]')?.textContent || '{}') };
    panels.forEach(panel => {
      panel.setAttribute('aria-label', text.selection);
      panel.querySelector('.avt-quote-context__title').textContent = text.selection;
      panel.querySelector('[data-avt-quote-previous]').textContent = text.previous_kept;
      ['append', 'resume', 'replace'].forEach(action => { panel.querySelector(`[data-avt-quote-${action}]`).textContent = text[action]; });
    });
    const field = selector => form.querySelector(selector);
    const status = message => panels.forEach(panel => { panel.hidden = false; panel.querySelector('[data-avt-quote-status]').textContent = message; });
    const render = () => {
      const summary = field('[data-avb-selected-setups]')?.value || '';
      const total = field('[data-avb-total-quantity]')?.value || '';
      panels.forEach(panel => {
        if (summary) panel.hidden = false;
        panel.querySelector('[data-avt-quote-summary]').textContent = summary;
        panel.querySelector('[data-avt-quote-total]').textContent = total ? text.total.replace('__COUNT__', total) : '';
      });
    };
    root.addEventListener('avontic:quote-updated', render);
    render();
    const params = new URLSearchParams(location.search);
    const handle = params.get('product');
    const variantId = params.get('variant');
    const planningQuantity = Number(params.get('quantity'));
    const planning = !variantId && Number.isInteger(planningQuantity) && planningQuantity > 0 && planningQuantity <= 100000;
    if (handle && !/^[\p{L}\p{N}™®_-]+$/u.test(handle)) return;
    if (!handle && !planning) return;
    const preference = params.get('case') || handle || 'help';
    if (!variantId && !planning) {
      const choice = [...form.querySelectorAll('[name="contact[Case preference]"]')].find(input => input.value === preference);
      if (choice) { choice.checked = true; choice.dispatchEvent(new Event('change', { bubbles: true })); }
      if (params.get('quantity')) status(text.unverified);
      return;
    }
    if (variantId && !/^\d+$/.test(variantId)) { status(text.unverified); return; }
    let previous = read(KEY);
    root.addEventListener('avontic:quote-cleared', () => {
      previous = null;
      panels.forEach(panel => { panel.querySelector('[data-avt-quote-draft-actions]').hidden = true; });
    });
    let incoming;
    status(text.loading);
    const submits = [...root.querySelectorAll('button[type="submit"]')].map(button => ({ button, disabled: button.disabled }));
    submits.forEach(({ button }) => { button.disabled = true; });
    try {
      if (planning) {
        let devices = [];
        try {
          const candidate = JSON.parse(params.get('devices') || '[]');
          if (Array.isArray(candidate) && candidate.length <= 3 && candidate.every(item => typeof item.model === 'string' && item.model.length <= 180 && Number.isInteger(item.quantity) && item.quantity > 0 && item.quantity <= 100000) && candidate.reduce((sum, item) => sum + item.quantity, 0) === planningQuantity) devices = candidate;
        } catch (_) { /* A plain quantity link can still start a planning request. */ }
        incoming = { key: `planning:${params.get('source') || ''}:${planningQuantity}:${JSON.stringify(devices)}`, title: '', model: '', quantity: planningQuantity, preference, devices: devices.length ? devices : undefined,
          summary: [params.get('source') === 'loadout-studio' ? 'Loadout Studio' : '', ...devices.map(item => `${item.model} × ${item.quantity}`)].filter(Boolean).join('\n') };
      } else {
      const prefix = location.pathname.split('/pages/')[0];
      const url = new URL(`${prefix}/products/${encodeURIComponent(handle)}`, location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('view', 'avontic-selection');
      ['preview_theme_id', '_fd', 'pb', 'country', 'currency', 'locale'].forEach(key => { if (params.has(key)) url.searchParams.set(key, params.get(key)); });
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error('request');
      const product = await response.json();
      const variant = product.variant;
      if (product.handle !== handle || !variant || variant.id !== variantId) throw new Error('selection');
      const packCount = Number(params.get('pack_count'));
      const requested = Number(params.get('quantity'));
      const quantity = Number.isInteger(packCount) && packCount > 0 ? packCount * variant.units : requested;
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100000) throw new Error('quantity');
      const options = product.optionNames.map((name, index) => ({ name, value: variant.options[index] }));
      const model = options.find(option => /model|device|size/i.test(option.name))?.value || '';
      const colors = options.filter(option => /colou?r/i.test(option.name)).map(option => `${option.name}: ${option.value}`).join(' / ');
      const aNumber = [params.get('model'), params.get('smartfit_model')].find(value => /^A\d{4}$/.test(value || '') && model.includes(value)) || '';
      const optionText = options.filter(option => option.name !== 'Title').map(option => `${option.name}: ${option.value}`).join(' · ');
      const packs = variant.units > 1 && quantity % variant.units === 0 ? text.packs.replace('__PACKS__', String(quantity / variant.units)).replace('__UNITS__', String(variant.units)).replace('__COUNT__', String(quantity)) : text.total.replace('__COUNT__', String(quantity));
      incoming = { key: `${handle}:${variantId}:${quantity}`, title: product.title, model, colors, aNumber, quantity, preference,
        summary: [product.title, optionText, packs, variant.available ? '' : text.availability].filter(Boolean).join('\n') };
      }
      const savedKey = previous?.fields?.find(item => item.name === 'contact[Selection key]')?.value;
      if (savedKey === incoming.key) {
        previous = read(PREVIOUS);
        status(text.restored);
      } else {
        if (previous?.fields?.some(item => item.name === 'contact[Estimated quantity]' && Number(item.value) > 0) || previous?.devices?.some(item => item.model || Number(item.quantity) > 0)) save(PREVIOUS, previous);
        else previous = null;
        const detail = { mode: 'replace', selection: incoming };
        root.dispatchEvent(new CustomEvent('avontic:quote-selection', { detail }));
        if (!detail.applied) throw new Error('form');
        status(planning ? text.planning_loaded : text.loaded);
      }
      panels.forEach(panel => {
        panel.querySelector('[data-avt-quote-draft-actions]').hidden = !previous;
        const run = mode => {
          const detail = { mode, selection: incoming, draft: previous };
          root.dispatchEvent(new CustomEvent('avontic:quote-selection', { detail }));
          if (!detail.applied) { status(text.limit); return; }
          status(mode === 'resume' ? text.resumed : mode === 'append' ? text.appended : planning ? text.planning_loaded : text.loaded);
          panels.forEach(item => {
            item.querySelector('[data-avt-quote-append]').hidden = mode === 'append';
            item.querySelector('[data-avt-quote-replace]').hidden = mode === 'replace';
          });
          render();
        };
        panel.querySelector('[data-avt-quote-append]').addEventListener('click', () => run('append'));
        panel.querySelector('[data-avt-quote-resume]').addEventListener('click', () => run('resume'));
        panel.querySelector('[data-avt-quote-replace]').addEventListener('click', () => run('replace'));
      });
      render();
    } catch (_) { status(text.unverified); }
    finally { submits.forEach(({ button, disabled }) => { button.disabled = disabled; }); }
  };
  if (document.readyState === 'complete') apply();
  else window.addEventListener('load', apply, { once: true });
})();
